module.exports = __webpack_public_path__ + "img/logo.5ab3f56.png";